import React from 'react';
import Typography from '@mui/material/Typography';

export default function Title() {
    return (
            <Typography id="title" variant="h2" component="h2" gutterBottom>
                {/* Get an accurate appraisal of your home. */}
            </Typography>
    )
}
